export default __webpack_public_path__ + "static/media/post_icon.3dc38369.svg";